import PropTypes from 'prop-types';
import React from 'react';

import Log from 'utils/Log';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error?.message || 'Could not load reviews',
    };
  }

  componentDidCatch(error, errorInfo) {
    Log.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <p data-testid="reviews-error" className="text-center">
          Could not load reviews
        </p>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
